import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ReferenceService } from 'src/app/core-module/services/reference.service';
import {AuditLocation} from '../../core-module/models/Locations/audit-location';
import { Audit } from 'src/app/core-module/models/Audits/audit';
import { LocationHolder } from 'src/app/core-module/models/Locations/location-holder';
import { LocationResult } from 'src/app/core-module/models/Locations/location-result';
import { FlattenedQuestionHolder } from 'src/app/core-module/models/Audits/flattened-question-holder';
import { LocalStorageService } from 'src/app/core-module/services/local-storage.service';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { UserLocationSave } from 'src/app/core-module/models/user-location-save';
import { AuthService } from 'src/app/core-module/services/auth.service';
import { UserSettings } from 'src/app/core-module/interfaces/user-settings';
import { HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';

@Component({
    selector: 'app-select-location',
    templateUrl: './select-location.component.html',
    styleUrls: ['./select-location.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectLocationComponent {

  selectedAudit: FlattenedQuestionHolder = new FlattenedQuestionHolder();
  locations: LocationHolder[] = [];
  selectedLocations: LocationHolder[] = [];
  topLevel: boolean = true;
  selectedLocation: LocationHolder = new LocationHolder();
  canStart: boolean = false;
  locationResult: LocationResult;
  areYouSure:boolean = false;
  noLocations:boolean = false;

  isEvent:boolean = false;
  EventWorkflowID: number = -1;

  incompleteAuditList:UserLocationSave[]=[];
  preSetLocationID:number = -1;

  constructor(private router: Router, private referenceService: ReferenceService, private auditService:AuditService, private authService:AuthService, private toastr: ToastrService){
    this.selectedAudit = new FlattenedQuestionHolder(this.router.currentNavigation()?.extras.state!['audit']);
    if (this.router.currentNavigation()?.extras.state!.hasOwnProperty('isEvent')){
      this.isEvent = this.router.currentNavigation()?.extras.state!['isEvent'];
    };
    if (this.router.currentNavigation()?.extras.state!.hasOwnProperty('EventWorkflowID')){
      this.EventWorkflowID = this.router.currentNavigation()?.extras.state!['EventWorkflowID'];
    };
    this.referenceService.getLocationsByAuditID(this.selectedAudit.AuditID,2).pipe(
      tap((res:HttpResponse<LocationResult>) =>{
        if(res!=null){
          this.locationResult = <LocationResult>res.body;            
          this.setCurrentLocationLevel();
        }
        if(this.locationResult.Locations.SubLocations.length == 0 || res == null){
          this.noLocations = true;
        }
      })
    ).subscribe();
  }

  ngOnInit(){
    if(this.selectedAudit.AuditID == -1){
      this.router.navigateByUrl('/startaudit'); 
      return;
    }
    this.auditService.reconcileLocalAudits().pipe(tap(removedGUIDs => {
      if (removedGUIDs.length > 0) {
        const auditText = removedGUIDs.length === 1 ? 'audit was' : 'audits were';
        this.toastr.addToastr(new Toastr({
          Type: 2,
          Message: `${removedGUIDs.length} locally saved ${auditText} removed because they are no longer active.`
        }));
      }
      this.refreshAudits();
    })).subscribe();
  }

  setCurrentLocationLevel(){
    this.locations = this.locationResult.Locations.SubLocations;
      this.initialPopulation(this.locations[0]);  
      this.resetLocations()    
  }
  initialPopulation(l:LocationHolder){
    this.selectedLocations = this.locations;
    //this.selectedLocation = this.locations[0];

  }
  chooseSublocation(l:LocationHolder){
    this.topLevel = false;
        this.selectedLocations = l.SubLocations;
        //this.selectedLocation = new LocationHolder();
    //this.selectedLocation = l.SubLocations[0];
  }

  selectLocation(l:LocationHolder){
    if(l.Location.HasPermission){
      this.canStart = true;
      this.areYouSure = false;
      this.selectedLocation = l;
      this.refreshAudits();
    }else{
      this.canStart = false;
    }


    
  }

  resetLocations(){
    this.topLevel = true;
    this.canStart = false;
    this.selectedLocations = this.locations;
    this.areYouSure = false;
  }

  startAudit(){
    if(this.isCurrentAudit()){
    }else{
      if(this.selectedLocation.Location.LocationID!=-1){
        this.router.navigateByUrl('/audit',{state: {"location": this.selectedLocation.Location,"audit":this.selectedAudit, "isEvent": this.isEvent, "EventWorkflowID": this.EventWorkflowID}});
      }
    }
  }
  forceNewAudit(){
    if(this.selectedLocation.Location.LocationID!=-1){
      this.router.navigateByUrl('/audit',{state: {"location": this.selectedLocation.Location,"audit":this.selectedAudit, "isEvent": this.isEvent, "EventWorkflowID": this.EventWorkflowID}});
    }  
  }
  jumpToAudit(){
    var fullAudit:FlattenedQuestionHolder = new FlattenedQuestionHolder();
    var username:string = "";
    this.authService.getUserName()
    .pipe(
      tap((a:any) => {
        username = a.Username;
      })
    )
    .subscribe();
    var fullAuditDetails = this.auditService.getLocalAudit(this.selectedAudit.AuditID,this.selectedLocation.Location.LocationID,username);
    //Add fullaudit from local data then enable below
    this.router.navigateByUrl('audit', { state: { "SavedAudit": fullAuditDetails.FlattenedQuestions[0], "SavedLocation": fullAuditDetails.Location } });
  }
  areReadyToClear(){
    this.areYouSure = true;
    
  }
  cancelReadyToClear(){
    this.areYouSure = false;
  }
  removeAudit(){
    var username:string = "";
    this.authService.getUserName()
    .pipe(
      tap((a:any) => {
        username = a.Username;
      })
    )
    .subscribe();
    //this .auditService.removeLocalAudit(,username);
    this.startAudit();
  }
  isCurrentAudit():boolean{
    var username: string = "";
    this.authService.getUserName().pipe(tap((e:any)=>{
      if(e!=null){
        username = e.Username;
      }
    })).subscribe();
    var isCurrent:boolean = false;
    var auditID = this.selectedAudit.AuditID;
    var locationID = this.selectedLocation.Location.LocationID;
    var tempIncompleteList:UserLocationSave[]=[];
    this.auditService.getLocalAudits().pipe(tap((e:UserLocationSave[])=>{
      if(e != null){
        var temp = <UserLocationSave[]>e
        temp.forEach(f=>{    
          if(f.Location.LocationID == locationID && f.Username == username && f.FlattenedQuestions[0].AuditID == auditID){
            f.FlattenedQuestions.forEach(g=>{
              tempIncompleteList.push(new UserLocationSave(f));
              if(g.AuditID == auditID){
                isCurrent = true;
              }
            })
          }
        })
      }
    })).subscribe();
    this.incompleteAuditList=tempIncompleteList;
    return isCurrent;
  }
  refreshAudits(){
    this.isCurrentAudit();
  }
}
